

























































































































































































































































































































































































































































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import DetailsDialog from "../Dialogs/DetailsDialog.vue";
import CreateDialog from "../Dialogs/CreateDialog.vue";
import { bus } from "../../main";
import { router } from "../../_router";
import { EnterpriseNominaResp } from "../../_models/enterpriseNominaResp";
import StoricoAttivitaDialog from "../Dialogs/StoricoAttivitaDialog.vue";
import * as user from "../../_store/user.module";
import * as data from "../../_store/data.module";
import { UserInfo } from "../../_models/userInfo";
import EditDialog from "../../components/Edit/EditDialog.vue";
import AssignDialog from "../../components/Dialogs/AssignDialog.vue";
import DownloadRecords from "../DownloadRecords.vue";
import * as temp from "../../_store/temp.module";

@Component({
  components: {
    DetailsDialog,
    CreateDialog,
    EditDialog,
    AssignDialog,
    DownloadRecords,
    StoricoAttivitaDialog
  }
})
export default class ListDataTable extends Vue {
  @Prop() params!: any;
  @Prop() tutorParams!: any;
  @Prop() richiesteParams!: any;
  @Prop() tutorFormParams!: any;
  @Prop() counterProvvisori!: number;
  @Prop() recordType!: string;
  @Prop() createDialogParams?: object;
  // @Prop() filterParams!: any;
  private loadingData: boolean;
  private anno: string[];
  private autorizzazione: string[];
  private anni: string[];
  private docResp: string[];
  private articolazioni: any;
  private anniScolastici: any[];

  private autorizzazioneFilter: string;
  private annoScolasticoFilter: any;
  private annoFilter: string;
  private docRespFilter: string;
  private articolazioneFilter: string;
  private sezioneFilter: string;
  private sezione: any[];
  private bloccoFilter: string;
  private blocchi: any[];
  private assegnazioneFilter: string;
  private assegnazioni: any[];
  private iscrittiFilter: string;
  private iscritti: any[];

  private search: string;
  private selected: any;
  // private flagConfirm: boolean;

  private showStoricoDialog: boolean;

  constructor() {
    super();
    this.search = "";
    this.loadingData = true;
    this.anno = ["3", "4", "5"];
    this.autorizzazione = ["Inviati", "Eliminati", "Confermati", "Tutti"];
    this.autorizzazioneFilter = "Tutti";
    this.anni = ["Tutti", "3", "4", "5"];
    this.annoFilter = "Tutti";
    this.docRespFilter = "Tutti";
    this.docResp = ["Inviati", "Eliminati", "Confermati", "Tutti"];
    this.articolazioni = this.params.listaArticolazioni;
    this.articolazioneFilter = "Tutte";
    this.selected = [];
    this.annoScolasticoFilter = 0;
    this.anniScolastici = [];
    this.sezioneFilter = "Nessuna";
    this.sezione = ["Nessuna", "A", "B", "C", "D", "E", "F"];
    this.bloccoFilter = "Tutti";
    this.blocchi = ["Tutti", "Non Bloccati", "Bloccati"];
    this.assegnazioneFilter = "Tutti";
    this.assegnazioni = ["Tutti", "Assegnati", "Non Assegnati"];
    this.iscrittiFilter = "Tutti";
    this.iscritti = ["Tutti", "Iscritti", "Non Iscritti"];

    this.showStoricoDialog = true;

    
    // this.flagConfirm = true;
  }
  get flagConfirm() {
    if (this.selected.length <= 0) {
      return true;
    } else {
      return false;
    }
  }

  get showSelect() {
    //aggiungere controllo sul tipo di assegnamento
    let route = this.$route.path

    if(route == "/tutorAllievi"){
      return false
    }else{
      return true;
    }
  }

  @Watch("annoScolasticoFilter")
  onAnnoScolasticoChange(value: string) {
    this.loadingData = true;
    this.changeAnnoScolastico();
    // bus.$emit("autorizzazioneFilter", value)
  }

  @Watch("annoFilter")
  onAutorizzazioneChange(value: string) {
    this.filterChange();
    // bus.$emit("autorizzazioneFilter", value)
  }

  @Watch("autorizzazioneFilter")
  onAnnoChange(value: string) {
    this.filterChange();
    // bus.$emit("autorizzazioneFilter", value)
  }

  @Watch("articolazioneFilter")
  onArticolazioneChange(value: string) {
    this.filterChange();
    // bus.$emit("autorizzazioneFilter", value)
  }

  @Watch("sezioneFilter")
  onSezioneChange(value: string) {
    this.filterChange();
  }

  @Watch("bloccoFilter")
  onBloccoChange(value: string) {
    this.filterChange();
  }

  @Watch("assegnazioneFilter")
  onAssegnazioneChange(value: string) {
    this.filterChange();
  }

  @Watch("iscrittiFilter")
  onIscrittiChange(value: string){
    this.filterChange();
  }

  filterChange() {
    var filters = {
      filtroAutorizzazione: "Tutti",
      filtroAnni: "",
      filtroDocResp: "",
      fitroArticolazione: "",
      filtroSezione: "",
      filtroBlocco: "",
      filtroAssegnazione: "",
      filtroIscrizioni: ""
    };
    if (this.params.filterType === "listaAllievi") {
      filters = {
        filtroAutorizzazione: this.autorizzazioneFilter,
        filtroAnni: this.annoFilter,
        filtroDocResp: "",
        fitroArticolazione: this.articolazioneFilter,
        filtroSezione: this.sezioneFilter,
        filtroBlocco: this.bloccoFilter,
        filtroAssegnazione: this.assegnazioneFilter,
        filtroIscrizioni: this.iscrittiFilter
      };
      bus.$emit("filtroAllievi", filters);
    } else if (this.params.filterType === "listaAziende") {
      filters = {
        filtroAutorizzazione: "",
        filtroAnni: "",
        filtroDocResp: this.docRespFilter,
        fitroArticolazione: "",
        filtroSezione: "",
        filtroBlocco: "",
        filtroAssegnazione: "",
        filtroIscrizioni: ""
      };
      bus.$emit("filtroAziende", filters);
    }
  }

  changeAnnoScolastico() {
    bus.$emit("changeAnnoScolastico", this.annoScolasticoFilter);
  }

  changeSicurezzaCheck(idUtente: number, statusCorso: boolean){
    var payload = {
      idUtente: idUtente,
      statusCorso: statusCorso
    };
    user.dispatchChangeCorsoSicurezzaStatus(this["$store"], payload)
    .catch(error => {
          if (error.response.status === 403) {
            bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
            this["$router"].push("/login");
          } else {
            bus.$emit(
              "errorOperation",
              "Errore nella modifica delle informazioni"
            );
          }
        });

  }

  block(item: any) {
    var payload = {
      idAllievo: item.idUtente,
      idIstitutoAnnoScolastico: item.idIstitutoAnnoScolastico,
      idClasse: item.idClasse,
      gestioneAlternanza: !item.gestioneAlternanza
    };

    if (confirm("Bloccare l'allievo dalla FSL Estiva?")) {
      user
        .dispatchChangeStudentActivityStatus(this["$store"], payload)
        .then(() => {
          bus.$emit("successfullOperation", "Utente bloccato con successo");
          item.gestioneAlternanza = false;
        })
        .catch(error => {
          if (error.response.status === 403) {
            bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
            this["$router"].push("/login");
          } else {
            bus.$emit(
              "errorOperation",
              "Errore nella modifica delle informazioni"
            );
          }
        });
    }
  }

  enable(item: any) {
    var payload = {
      idAllievo: item.idUtente,
      idIstitutoAnnoScolastico: item.idIstitutoAnnoScolastico,
      idClasse: item.idClasse,
      gestioneAlternanza: !item.gestioneAlternanza
    };
    if (confirm("Sbloccare l'allievo per l'attività di FSL Estiva?")) {
      user
        .dispatchChangeStudentActivityStatus(this["$store"], payload)
        .then(() => {
          bus.$emit("successfullOperation", "Utente sbloccato con successo");
          item.gestioneAlternanza = true;
        })
        .catch(error => {
          if (error.response.status === 403) {
            bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
            this["$router"].push("/login");
          } else {
            bus.$emit(
              "errorOperation",
              "Errore nella modifica delle informazioni"
            );
          }
        });
    }
  }

  reviewAutorizzazione(item: any) {
    var userInfo: UserInfo = user.readUserInfo(this["$store"]);
    var ruoloUtente: any = userInfo.ruoloUtente;
    router.push({
      name: "review",
      params: {
        docType: "autorizzazioneStudente",
        idDoc: item.idDocAutorizzazione,
        idStatoDoc: item.idStatoDoc,
        ruoloUtente: ruoloUtente
      }
    });
  }

  deleteAssociazione(idRichiesta: number) {
    var payload = {
      idRichiesta: idRichiesta
    };
    user
      .dispatchDeleteAssociazioneAllievoAzienda(this["$store"], payload)
      .then(() => {
        bus.$emit("successfullOperation", "Abbinamenti eliminato con successo");
        bus.$emit("loadStudentsTutor");
      })
      .catch(error => {
        if (error.response.status === 403) {
          bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
          this["$router"].push("/login");
        } else {
          bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
        }
      });
  }

  confirmAssignments() {
    var incomplete: boolean = false;
    var payload = {
      idRichiesta: 0,
      attivita: ""
    };
    var payload2 = {
      denominazioneAzienda: "",
      tirocinante: "",
      emailAzienda: "",
      emailTirocinante: "",
      activityType: ""
    };
    if (this.params.activityType === "tirocinioFormativo") {
      this.selected.forEach((element: any) => {
        payload.idRichiesta = element.idRichiesta;
        payload.attivita = this.params.activityType;
        if (element.tutorFormativo === "") {
          incomplete = true;
        }
        if (element.azienda === null) {
          incomplete = true;
        }
        if (
          element.tutorFormativo !== "" &&
          element.azienda !== null &&
          element.idRichiesta !== null
        ) {
          user
            .dispatchSaveAssegnazioneAllievoAzienda(this["$store"], payload)
            .then(() => {
              if (!incomplete) {
                bus.$emit(
                  "successfullOperation",
                  "Abbinamenti salvati con successo"
                );
              } else {
                bus.$emit(
                  "warning",
                  "Uno o più abbinamenti non sono stati salvati perchè incompleti"
                );
              }
              data
                .dispatchDetailsAbbinamentoAllievoAzienda(
                  this["$store"],
                  payload
                )
                .then(result => {
                  payload2 = {
                    denominazioneAzienda: result.Denominazione,
                    tirocinante: result.Cognome + " " + result.Nome,
                    emailAzienda: result.EmailAzienda,
                    emailTirocinante: result.EmailTirocinante,
                    activityType: this.params.activityType
                  };
                  user
                    .dispacthSendEmailAssegnazioneAllievoAzienda(
                      this["$store"],
                      payload2
                    )
                    .catch(error => {
                      if (error.response.status === 403) {
                        bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
                        this["$router"].push("/login");
                      } else {
                        bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
                      }
                    });
                })
                .catch(error => {
                  if (error.response.status === 403) {
                    bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
                    this["$router"].push("/login");
                  } else {
                    bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
                  }
                });
              bus.$emit("loadStudentsTutor");
            })
            .catch(error => {
              if (error.response.status === 403) {
                bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
                this["$router"].push("/login");
              } else {
                bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
              }
            });
        }
      });
    } else if (this.params.activityType === "alternanza") {
      this.selected.forEach((element: any) => {
        payload.idRichiesta = element.idRichiesta;
        payload.attivita = this.params.activityType;
        if (element.tutorFormativo === "") {
          incomplete = true;
        }
        if (element.azienda === null) {
          incomplete = true;
        }
        if (
          element.tutorFormativo !== "" &&
          element.azienda !== null &&
          element.idRichiesta !== null
        ) {
          user
            .dispatchSaveAssegnazioneAllievoAzienda(this["$store"], payload)
            .then(() => {
              if (!incomplete) {
                bus.$emit(
                  "successfullOperation",
                  "Abbinamenti salvati con successo"
                );
              } else {
                bus.$emit(
                  "warning",
                  "Uno o più abbinamenti non sono stati salvati perchè incompleti"
                );
              }
              data
                .dispatchDetailsAbbinamentoAllievoAzienda(
                  this["$store"],
                  payload
                )
                .then(result => {
                  payload2 = {
                    denominazioneAzienda: result.Denominazione,
                    tirocinante: result.Cognome + " " + result.Nome,
                    emailAzienda: result.EmailAzienda,
                    emailTirocinante: result.EmailTirocinante,
                    activityType: this.params.activityType
                  };
                  user
                    .dispacthSendEmailAssegnazioneAllievoAzienda(
                      this["$store"],
                      payload2
                    )
                    .catch(error => {
                      if (error.response.status === 403) {
                        bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
                        this["$router"].push("/login");
                      } else {
                        bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
                      }
                    });
                })
                .catch(error => {
                  if (error.response.status === 403) {
                    bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
                    this["$router"].push("/login");
                  } else {
                    bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
                  }
                });
              bus.$emit("loadStudentsTutor");
            })
            .catch(error => {
              if (error.response.status === 403) {
                bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
                this["$router"].push("/login");
              } else {
                bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
              }
            });
        }
      });
    } else if (this.params.activityType === "tirocinioEstivo") {
      this.selected.forEach((element: any) => {
        payload.idRichiesta = element.idRichiesta;
        payload.attivita = this.params.activityType;
        if (element.tutorFormativo === "") {
          incomplete = true;
        }
        if (element.azienda === null) {
          incomplete = true;
        }
        if (
          element.tutorFormativo !== "" &&
          element.azienda !== null &&
          element.idRichiesta !== null
        ) {
          user
            .dispatchSaveAssegnazioneAllievoAzienda(this["$store"], payload)
            .then(() => {
              if (!incomplete) {
                bus.$emit(
                  "successfullOperation",
                  "Abbinamenti salvati con successo"
                );
              } else {
                bus.$emit(
                  "warning",
                  "Uno o più abbinamenti non sono stati salvati perchè incompleti"
                );
              }
              data
                .dispatchDetailsAbbinamentoAllievoAzienda(
                  this["$store"],
                  payload
                )
                .then(result => {
                  payload2 = {
                    denominazioneAzienda: result.Denominazione,
                    tirocinante: result.Cognome + " " + result.Nome,
                    emailAzienda: result.EmailAzienda,
                    emailTirocinante: result.EmailTirocinante,
                    activityType: this.params.activityType
                  };
                  user
                    .dispacthSendEmailAssegnazioneAllievoAzienda(
                      this["$store"],
                      payload2
                    )
                    .catch(error => {
                      if (error.response.status === 403) {
                        bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
                        this["$router"].push("/login");
                      } else {
                        bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
                      }
                    });
                })
                .catch(error => {
                  if (error.response.status === 403) {
                    bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
                    this["$router"].push("/login");
                  } else {
                    bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
                  }
                });
              bus.$emit("loadStudentsTutor");
            })
            .catch(error => {
              if (error.response.status === 403) {
                bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
                this["$router"].push("/login");
              } else {
                bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
              }
            });
        }
      });
    } else if (this.params.activityType === "tirocinioReIns") {
      this.selected.forEach((element: any) => {
        payload.idRichiesta = element.idRichiesta;
        payload.attivita = this.params.activityType;
        if (element.tutorFormativo === "") {
          incomplete = true;
        }
        if (element.azienda === null) {
          incomplete = true;
        }
        if (
          element.tutorFormativo !== "" &&
          element.azienda !== null &&
          element.idRichiesta !== null
        ) {
          user
            .dispatchSaveAssegnazioneAllievoAzienda(this["$store"], payload)
            .then(() => {
              if (!incomplete) {
                bus.$emit(
                  "successfullOperation",
                  "Abbinamenti salvati con successo"
                );
              } else {
                bus.$emit(
                  "warning",
                  "Uno o più abbinamenti non sono stati salvati perchè incompleti"
                );
              }
              data
                .dispatchDetailsAbbinamentoAllievoAzienda(
                  this["$store"],
                  payload
                )
                .then(result => {
                  payload2 = {
                    denominazioneAzienda: result.Denominazione,
                    tirocinante: result.Cognome + " " + result.Nome,
                    emailAzienda: result.EmailAzienda,
                    emailTirocinante: result.EmailTirocinante,
                    activityType: this.params.activityType
                  };
                  user
                    .dispacthSendEmailAssegnazioneAllievoAzienda(
                      this["$store"],
                      payload2
                    )
                    .catch(error => {
                      if (error.response.status === 403) {
                        bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
                        this["$router"].push("/login");
                      } else {
                        bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
                      }
                    });
                })
                .catch(error => {
                  if (error.response.status === 403) {
                    bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
                    this["$router"].push("/login");
                  } else {
                    bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
                  }
                });
              bus.$emit("loadStudentsTutor");
            })
            .catch(error => {
              if (error.response.status === 403) {
                bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
                this["$router"].push("/login");
              } else {
                bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
              }
            });
        }
      });
    }
  }

  loadAnniScolastici() {
    data
      .dispatchAnniScolastici(this["$store"])
      .then(result => {
        result.forEach((element: any) => {
          this.anniScolastici.push({
            //@ts-ignore
            nomeAnno: element.nomeAnnoScolastico,
            //@ts-ignore
            idAnno: element.idAnnoScolastico
          });
        });
      })
      .catch(error => {
        if (error.response.status === 403) {
          bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
          this["$router"].push("/login");
        } else {
          bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
        }
      });
  }

  created() {
    var idAnnoScolastico = temp.readIdAnnoScolastico(this["$store"]);
    this.loadAnniScolastici();
    this.annoScolasticoFilter = idAnnoScolastico;

    bus.$on("dataLoaded", () => {
      this.loadingData = false;
      this.selected = [];
    });

    bus.$on("destroyStoricoDialog", async () => {
      this.showStoricoDialog = false;
      await this.$nextTick();
      this.showStoricoDialog = true;
    });

  }
}
